import { render, staticRenderFns } from "./LocalizacaoChart.vue?vue&type=template&id=2ccbfa7a"
import script from "./LocalizacaoChart.vue?vue&type=script&lang=js"
export * from "./LocalizacaoChart.vue?vue&type=script&lang=js"
import style0 from "./LocalizacaoChart.vue?vue&type=style&index=0&id=2ccbfa7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports